import React from 'react';
import { Icon, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';
import { columns, getFundsDesignationTextByValue } from 'erisxkit/client';

const DEFAULT_ASSET_TYPE = 'USD';

const custodianAccountMetadata = (
  assetTypeOptions,
  viewReconciliations = undefined,
) => [
  {
    Header: 'Identity',
    columns: [
      {
        Header: 'Firm Code',
        id: 'firmCode',
        accessor: (d) => d.firmCode,
        width: columns.FIRM_CODE,
      },
      {
        Header: 'Account Code',
        id: 'accountCode',
        accessor: (d) => d.accountCode,
        width: columns.ACCOUNT_CODE,
      },
      {
        Header: 'Account Name',
        id: 'name',
        accessor: (d) => d.name,
        width: columns.ACCOUNT_NAME,
      },
      {
        Header: 'Subexchange',
        id: 'subExchangeLabel',
        accessor: 'subExchangeLabel',
      },
      {
        Header: 'Provider',
        id: 'provider',
        width: 80,
        accessor: (d) => _.get(d, 'provider', ''),
      },
      {
        Header: 'Provider Account Id',
        id: 'providerAccountId',
        accessor: 'providerAccountId',
        className: 'mono',
      },
      {
        Header: 'Funds Designation',
        id: 'fundsDesignation',
        accessor: ({ fundsDesignation = '' }) =>
          getFundsDesignationTextByValue(fundsDesignation) || fundsDesignation,
        width: 150,
      },
    ],
  },
  {
    Header: 'Balance',
    columns: [
      {
        Header: 'Asset Type',
        id: 'assetType',
        width: 80,
        accessor: (d) => {
          const balances = _.get(d, 'balances', {});
          const assetType = _.get(d, 'assetType', '');
          const defaultAmount =
            balances && balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              ? balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              : '';
          if (assetType) {
            return assetType;
          }
          if (defaultAmount) {
            return DEFAULT_ASSET_TYPE;
          }
        },
        filterMethod: (filter, row) => {
          if (filter.value.value === 'All') {
            return true;
          }
          return row[filter.id] === filter.value.value.toUpperCase();
        },
        Filter: ({ filter, onChange }) => (
          <Dropdown
            onChange={(event, data) => onChange(data)}
            options={assetTypeOptions}
            defaultValue="All"
            selectOnBlur={false}
          />
        ),
      },
      {
        Header: 'Amount',
        id: 'amount',
        accessor: (d) => {
          const balances = _.get(d, 'balances', {});
          const assetType = _.get(d, 'assetType', '').toLowerCase();
          const defaultAmount =
            balances && balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              ? balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              : '';
          const amount = balances && assetType ? balances[assetType] : '';
          if (!assetType) {
            return defaultAmount;
          }
          return amount;
        },
        className: 'text-right mono',
        filterable: false,
      },
    ],
  },
  {
    columns: [
      {
        Header: '',
        id: 'action',
        maxWidth: 32,
        filterable: false,
        Cell: (row) => (
          <span>
            {
              <Icon
                link
                title="View Reconciliation History"
                onClick={() => {
                  if (viewReconciliations) {
                    viewReconciliations(row.original.accountId);
                  }
                }}
                color="grey"
                name="arrow alternate circle right outline"
              />
            }
          </span>
        ),
      },
    ],
  },
];

export default custodianAccountMetadata;
